// import { FaFacebook, FaYoutube, FaInstagram, FaTiktok, FaTwitter, FaGlobe, FaWhatsapp } from 'react-icons/fa';
// import { FaTelegram } from 'react-icons/fa6';
// import { FiLink } from 'react-icons/fi';
// import { BsPatchCheckFill } from 'react-icons/bs';
// import { getChannels } from '../api/publicApi';
// import useFetch from '../hooks/useFetch';
// import { SkeletonChannelItem } from '../components/Skeleton';

// const DESC_MAX = 28;

// // Matches PlatformType enum: facebook | youtube | instagram | tiktok | twitter | website | telegram | whatsapp | other
// const PLATFORM_ICONS = {
//   facebook: <FaFacebook color="#1877F2" size={22} />,
//   youtube: <FaYoutube color="#FF0000" size={22} />,
//   instagram: <FaInstagram color="#E1306C" size={22} />,
//   tiktok: <FaTiktok size={22} />,
//   twitter: <FaTwitter color="#1DA1F2" size={22} />,
//   website: <FaGlobe size={22} />,
//   telegram: <FaTelegram color="#0088cc" size={22} />,
//   whatsapp: <FaWhatsapp color="#25D366" size={22} />,
//   other: <FiLink size={22} />,
// };

// /* Small badge icons overlaid on avatar */
// const BADGE_ICONS = {
//   facebook: <FaFacebook color="#fff" size={10} />,
//   youtube: <FaYoutube color="#fff" size={10} />,
//   instagram: <FaInstagram color="#fff" size={10} />,
//   tiktok: <FaTiktok color="#fff" size={10} />,
//   twitter: <FaTwitter color="#fff" size={10} />,
//   website: <FaGlobe color="#fff" size={10} />,
//   telegram: <FaTelegram color="#fff" size={10} />,
//   whatsapp: <FaWhatsapp color="#fff" size={10} />,
//   other: <FiLink color="#fff" size={10} />,
// };

// const BADGE_BG = {
//   facebook: '#1877F2',
//   youtube: '#FF0000',
//   instagram: '#E1306C',
//   tiktok: '#000000',
//   twitter: '#1DA1F2',
//   website: '#8B1512',
//   telegram: '#0088cc',
//   whatsapp: '#25D366',
//   other: '#666',
// };

// const PLATFORM_LABELS = {
//   facebook: 'Facebook',
//   youtube: 'Youtube',
//   instagram: 'Instagram',
//   tiktok: 'Tik Tok',
//   twitter: 'Twitter / X',
//   website: 'SITE INTERNET',
//   telegram: 'Telegram',
//   whatsapp: 'WhatsApp',
//   other: 'Autres',
// };

// const BTN_LABELS = {
//   facebook: 'Suivre',
//   youtube: 'S\'abonner',
//   instagram: 'Suivre',
//   tiktok: 'Suivre',
//   twitter: 'Suivre',
//   website: 'Suivre',
//   telegram: 'REJOINDRE',
//   whatsapp: 'REJOINDRE',
//   other: 'REJOINDRE',
// };

// // Ordered display
// const PLATFORM_ORDER = ['facebook', 'youtube', 'instagram', 'tiktok', 'twitter', 'website', 'telegram', 'whatsapp', 'other'];

// /* Helper function to detect app store and return type */
// function getAppStoreType(url) {
//   if (!url) return null;
//   const urlLower = url.toLowerCase();

//   // Check for Play Store (full and shortened)
//   if (urlLower.includes('play.google.com') || urlLower.includes('google.com/play') || urlLower.includes('play.app')) {
//     return 'playstore';
//   }

//   // Check for App Store (full and shortened apple.co)
//   if (urlLower.includes('appstore.com') ||
//     urlLower.includes('apps.apple.com') ||
//     urlLower.includes('itunes.apple.com') ||
//     urlLower.includes('apple.co')) {
//     return 'appstore';
//   }

//   return null;
// }

// /* Helper function to detect app store links and return appropriate button label */
// function getButtonLabel(platform, url) {
//   if (!url) return BTN_LABELS[platform];

//   const storeType = getAppStoreType(url);
//   if (storeType) {
//     return 'Télécharger';
//   }

//   // Fallback to platform-specific label
//   return BTN_LABELS[platform];
// }

// export default function CanauxPage() {
//   const { data, loading, error } = useFetch(getChannels, { limit: 100 }, []);
//   const channels = data?.data || [];

//   const grouped = channels.reduce((acc, ch) => {
//     const key = ch.platform_type || 'other';
//     if (!acc[key]) acc[key] = [];
//     acc[key].push(ch);
//     return acc;
//   }, {});

//   const orderedKeys = PLATFORM_ORDER.filter(k => grouped[k]);

//   return (
//     <div className="canaux-page invisible-scrollbar" style={{ width: '80%', margin: '0 auto' }}>
//       {loading ? (
//         PLATFORM_ORDER.slice(0, 3).map(p => (
//           <div key={p} className="channel-section">
//             <div className="channel-section-title" style={{ width: 120, height: 16, background: '#eee', borderRadius: 4, marginBottom: 12 }} />
//             <div className="channel-group">
//               {Array.from({ length: 3 }).map((_, i) => <SkeletonChannelItem key={i} />)}
//             </div>
//           </div>
//         ))
//       ) : error ? (
//         <div style={{ padding: 60, textAlign: 'center', color: '#888' }}>
//           <FiLink size={36} style={{ display: 'block', margin: '0 auto 12px' }} />
//           <p>Impossible de charger les canaux de communication.</p>
//         </div>
//       ) : channels.length === 0 ? (
//         <div style={{ padding: 60, textAlign: 'center', color: '#888' }}>
//           <FiLink size={36} style={{ display: 'block', margin: '0 auto 12px' }} />
//           <p>Aucun canal de communication disponible.</p>
//         </div>
//       ) : (
//         <>
//           {/* Regular Channels Sections */}
//           {orderedKeys.map(platform => {
//             // Separate regular channels from app store links
//             const regularChannels = grouped[platform].filter(ch => !getAppStoreType(ch.url_connexion));
//             const appStoreLinks = grouped[platform].filter(ch => getAppStoreType(ch.url_connexion));

//             return (
//               <div key={platform} className="channel-section">
//                 <div className="channel-section-title">{PLATFORM_LABELS[platform]}</div>
//                 <div className="channel-group px-3">
//                   {/* Render regular channel cards */}
//                   {regularChannels.map(ch => (
//                     <div key={ch.id} className="channel-card-col">
//                       <div className="channel-item">
//                         {/* Avatar with platform badge overlay */}
//                         <div className="channel-avatar-wrapper">
//                           {ch.icone_url ? (
//                             <img
//                               src={ch.icone_url}
//                               alt={ch.nom_canal}
//                               className="channel-avatar-img"
//                               onError={(e) => {
//                                 e.target.style.display = 'none';
//                                 e.target.parentElement.querySelector('.channel-avatar-fallback-hidden')?.classList.remove('channel-avatar-fallback-hidden');
//                               }}
//                             />
//                           ) : null}
//                           <div
//                             className={`channel-avatar-fallback${ch.icone_url ? ' channel-avatar-fallback-hidden' : ''}`}>
//                             {PLATFORM_ICONS[platform]}
//                           </div>
//                           <span
//                             className="channel-badge"
//                             style={{ background: BADGE_BG[platform] }}
//                           >
//                             {BADGE_ICONS[platform]}
//                           </span>
//                         </div>

//                         {/* Channel info */}
//                         <div className="channel-info">
//                           <div className="channel-name-row">
//                             <span
//                               className="channel-name"
//                               title={ch.nom_canal && ch.nom_canal.length > 25 ? ch.nom_canal : undefined}
//                             >
//                               {ch.nom_canal}
//                             </span>
//                             {ch.is_verified && (
//                               <BsPatchCheckFill size={14} color="#1877F2" className="channel-verified" />
//                             )}
//                           </div>
//                           <div
//                             className="channel-handle"
//                             title={ch.description && ch.description.length > DESC_MAX ? ch.description : undefined}
//                           >
//                             {ch.description && ch.description.length > DESC_MAX
//                               ? `${ch.description.slice(0, DESC_MAX)}…`
//                               : ch.description
//                             }
//                           </div>
//                         </div>

//                         {/* Follow / Subscribe button */}
//                         <a href={ch.url_connexion} target="_blank" rel="noreferrer" className="channel-btn-link">
//                           <button className="btn-follow d-flex align-items-center justify-content-center">
//                             {getButtonLabel(platform, ch.url_connexion)}
//                           </button>
//                         </a>
//                       </div>
//                     </div>
//                   ))}

//                   {/* App Store / Play Store cards - only in 'other' section */}
//                   {platform === 'other' && (
//                     <>
//                       {/* Collect all app store links from all platforms */}
//                       {Object.values(grouped).flat().filter(ch => getAppStoreType(ch.url_connexion)).map(ch => {
//                         const storeType = getAppStoreType(ch.url_connexion);
//                         const isPlayStore = storeType === 'playstore';

//                         return (
//                           <div key={ch.id} className="channel-card-col">
//                             <a
//                               href={ch.url_connexion}
//                               target="_blank"
//                               rel="noreferrer"
//                               style={{ textDecoration: 'none', display: 'block', height: '100%' }}
//                             >
//                               <div
//                                 style={{
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'flex-start',
//                                   gap: '12px',
//                                   padding: '12px 16px',
//                                   background: '#000',
//                                   border: '1px solid #333',
//                                   borderRadius: '8px',
//                                   minHeight: '72px',
//                                   transition: 'all 0.2s ease',
//                                   cursor: 'pointer',
//                                   height: '100%'
//                                 }}
//                                 onMouseEnter={(e) => {
//                                   e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
//                                   e.currentTarget.style.transform = 'translateY(-2px)';
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   e.currentTarget.style.boxShadow = 'none';
//                                   e.currentTarget.style.transform = 'translateY(0)';
//                                 }}
//                               >
//                                 {/* Icon */}
//                                 {isPlayStore ? (
//                                   <img
//                                     src="/playstore-icon.png"
//                                     alt="Google Play"
//                                     style={{
//                                       width: '40px',
//                                       height: '40px',
//                                       flexShrink: 0,
//                                       objectFit: 'contain'
//                                     }}
//                                   />
//                                 ) : (
//                                   <img
//                                     src="/applelogowhite.webp"
//                                     alt="App Store"
//                                     style={{
//                                       width: '40px',
//                                       height: '40px',
//                                       flexShrink: 0,
//                                       objectFit: 'contain'
//                                     }}
//                                   />
//                                 )}

//                                 {/* Text Content */}
//                                 <div style={{
//                                   display: 'flex',
//                                   flexDirection: 'column',
//                                   gap: '2px',
//                                   minWidth: 0
//                                 }}>
//                                   <span style={{
//                                     fontSize: '11px',
//                                     fontWeight: '600',
//                                     color: '#aaa',
//                                     letterSpacing: '0.5px',
//                                     overflow: 'hidden',
//                                     textOverflow: 'ellipsis',
//                                     whiteSpace: 'nowrap'
//                                   }}>
//                                     {isPlayStore ? 'L\'OBTENIR SUR' : 'Télécharger dans'}
//                                   </span>
//                                   <span style={{
//                                     fontSize: '16px',
//                                     fontWeight: '700',
//                                     color: '#fff',
//                                     overflow: 'hidden',
//                                     textOverflow: 'ellipsis',
//                                     whiteSpace: 'nowrap'
//                                   }}>
//                                     {isPlayStore ? 'Google Play' : ' l’ App Store'}
//                                   </span>
//                                 </div>
//                               </div>
//                             </a>
//                           </div>
//                         );
//                       })}
//                     </>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </>
//       )}
//     </div>
//   );
// }

import { FaFacebook, FaYoutube, FaInstagram, FaTiktok, FaTwitter, FaGlobe, FaWhatsapp } from 'react-icons/fa';
import { FaTelegram } from 'react-icons/fa6';
import { FiLink } from 'react-icons/fi';
import { BsPatchCheckFill } from 'react-icons/bs';
import { getChannels } from '../api/publicApi';
import useFetch from '../hooks/useFetch';
import { SkeletonChannelItem } from '../components/Skeleton';

const DESC_MAX = 28;

// Matches PlatformType enum: facebook | youtube | instagram | tiktok | twitter | website | telegram | whatsapp | other
const PLATFORM_ICONS = {
  facebook:  <FaFacebook color="#1877F2" size={22} />,
  youtube:   <FaYoutube color="#FF0000" size={22} />,
  instagram: <FaInstagram color="#E1306C" size={22} />,
  tiktok:    <FaTiktok size={22} />,
  twitter:   <FaTwitter color="#1DA1F2" size={22} />,
  website:   <FaGlobe size={22} />,
  telegram:  <FaTelegram color="#0088cc" size={22} />,
  whatsapp:  <FaWhatsapp color="#25D366" size={22} />,
  other:     <FiLink size={22} />,
};

/* Small badge icons overlaid on avatar */
const BADGE_ICONS = {
  facebook:  <FaFacebook color="#fff" size={10} />,
  youtube:   <FaYoutube color="#fff" size={10} />,
  instagram: <FaInstagram color="#fff" size={10} />,
  tiktok:    <FaTiktok color="#fff" size={10} />,
  twitter:   <FaTwitter color="#fff" size={10} />,
  website:   <FaGlobe color="#fff" size={10} />,
  telegram:  <FaTelegram color="#fff" size={10} />,
  whatsapp:  <FaWhatsapp color="#fff" size={10} />,
  other:     <FiLink color="#fff" size={10} />,
};

const BADGE_BG = {
  facebook: '#1877F2',
  youtube: '#FF0000',
  instagram: '#E1306C',
  tiktok: '#000000',
  twitter: '#1DA1F2',
  website: '#8B1512',
  telegram: '#0088cc',
  whatsapp: '#25D366',
  other: '#666',
};

const PLATFORM_LABELS = {
  facebook: 'Facebook',
  youtube: 'Youtube',
  instagram: 'Instagram',
  tiktok: 'Tik Tok',
  twitter: 'Twitter / X',
  website: 'SITE INTERNET',
  telegram: 'Telegram',
  whatsapp: 'WhatsApp',
  other: 'Autres',
};

const BTN_LABELS = {
  facebook: 'Suivre',
  youtube: 'S’abonner',
  instagram: 'Suivre',
  tiktok: 'Suivre',
  twitter: 'Suivre',
  website: 'Suivre',
  telegram: 'REJOINDRE',
  whatsapp: 'REJOINDRE',
  other: 'REJOINDRE',
};

// Ordered display
const PLATFORM_ORDER = ['facebook', 'youtube', 'instagram', 'tiktok', 'twitter', 'website', 'telegram', 'whatsapp', 'other'];

/* Helper function to detect app store links and return appropriate button label */
function getButtonLabel(platform, url) {
  if (!url) return BTN_LABELS[platform];
  
  const urlLower = url.toLowerCase();
  
  // Check for Play Store or App Store links
  if (urlLower.includes('play.google.com') || urlLower.includes('appstore.com') || 
      urlLower.includes('apps.apple.com') || urlLower.includes('itunes.apple.com')) {
    return 'Télécharger';
  }
  
  // Fallback to platform-specific label
  return BTN_LABELS[platform];
}

export default function CanauxPage() {
  const { data, loading, error } = useFetch(getChannels, { limit: 100 }, []);
  const channels = data?.data || [];

  const grouped = channels.reduce((acc, ch) => {
    const key = ch.platform_type || 'other';
    if (!acc[key]) acc[key] = [];
    acc[key].push(ch);
    return acc;
  }, {});

  const orderedKeys = PLATFORM_ORDER.filter(k => grouped[k]);

  return (
    <div className="canaux-page invisible-scrollbar" style={{ width: '80%', margin: '0 auto' }}>
      {loading ? (
        PLATFORM_ORDER.slice(0, 3).map(p => (
          <div key={p} className="channel-section">
            <div className="channel-section-title" style={{ width: 120, height: 16, background: '#eee', borderRadius: 4, marginBottom: 12 }} />
            <div className="channel-group">
              {Array.from({ length: 3 }).map((_, i) => <SkeletonChannelItem key={i} />)}
            </div>
          </div>
        ))
      ) : error ? (
        <div style={{ padding: 60, textAlign: 'center', color: '#888' }}>
          <FiLink size={36} style={{ display: 'block', margin: '0 auto 12px' }} />
          <p>Impossible de charger les canaux de communication.</p>
        </div>
      ) : channels.length === 0 ? (
        <div style={{ padding: 60, textAlign: 'center', color: '#888' }}>
          <FiLink size={36} style={{ display: 'block', margin: '0 auto 12px' }} />
          <p>Aucun canal de communication disponible.</p>
        </div>
      ) : (
        <>
          {orderedKeys.map(platform => (
            <div key={platform} className="channel-section">
              <div className="channel-section-title">{PLATFORM_LABELS[platform]}</div>
              <div className="channel-group px-3">
                {grouped[platform].map(ch => (
                  <div key={ch.id} className="channel-card-col">
                    <div className="channel-item">
                      {/* Avatar with platform badge overlay */}
                      <div className="channel-avatar-wrapper">
                        {ch.icone_url ? (
                          <img
                            src={ch.icone_url}
                            alt={ch.nom_canal}
                            className="channel-avatar-img"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.parentElement.querySelector('.channel-avatar-fallback-hidden')?.classList.remove('channel-avatar-fallback-hidden');
                            }}
                          />
                        ) : null}
                        <div
                          className={`channel-avatar-fallback${ch.icone_url ? ' channel-avatar-fallback-hidden' : ''}`}>
                          {PLATFORM_ICONS[platform]}
                        </div>
                        <span
                          className="channel-badge"
                          style={{ background: BADGE_BG[platform] }}
                        >
                          {BADGE_ICONS[platform]}
                        </span>
                      </div>

                      {/* Channel info */}
                      <div className="channel-info">
                        <div className="channel-name-row">
                          <span 
                            className="channel-name"
                            title={ch.nom_canal && ch.nom_canal.length > 25 ? ch.nom_canal : undefined}
                          >
                            {ch.nom_canal}
                          </span>
                          {ch.is_verified && (
                            <BsPatchCheckFill size={14} color="#1877F2" className="channel-verified" />
                          )}
                        </div>
                        <div 
                          className="channel-handle"
                          title={ch.description && ch.description.length > DESC_MAX ? ch.description : undefined}
                        >
                          {ch.description && ch.description.length > DESC_MAX 
                            ? `${ch.description.slice(0, DESC_MAX)}…`
                            : ch.description
                          }
                        </div>
                     </div>

                      {/* Follow / Subscribe button */}
                      <a href={ch.url_connexion} target="_blank" rel="noreferrer" className="channel-btn-link">
                        <button className="btn-follow d-flex align-items-center justify-content-center">
                          {getButtonLabel(platform, ch.url_connexion)}
                        </button>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Mobile Applications Section - Mobile Only */}
          <div className="channel-section d-md-none" style={{ marginTop: '40px' }}>
            {/* <div className="channel-section-title">APPLICATIONS MOBILES</div> */}
            <div style={{ display: 'flex', gap: '0', justifyContent: 'center', flexWrap: 'nowrap', maxWidth: '400px', margin: '0 auto' }}>
              {/* Apple App Store */}
              <div className='d-flex justify-content-center align-items-center' style={{ flex: '1', minWidth: 0 }}>
                <a 
                  href="https://apps.apple.com/us/app/minist%C3%A8re-catho-mis%C3%A9ricorde/id6801453231" 
                  target="_blank" 
                  rel="noreferrer"
                  className='w-100'
                  title="Télécharger sur l'App Store"
                >
                  <img src="/app-store-badge-fr.webp" alt="Télécharger dans l'App Store" style={{ height: '50px', maxWidth: '100%', width:'95%' }} />
                </a>
              </div>

              {/* Google Play Store */}
              <div className='d-flex justify-content-center align-items-center' style={{ flex: '1',  minWidth: 0 }}>
                <a 
                  href={'#'||"https://play.google.com/store/apps/details?id=com.ministeremc" }
                  // target="_blank" 
                  rel="noreferrer"
                  className='w-100'
                  title="Obtenir sur Google Play"
                >
                  <img src="/google-play-badge-fr.png" alt="L'obtenir sur Google Play" style={{ height: '50px', maxWidth: '100%',width:'95%' }} />
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
